import { GridDataSource } from '../cms/GridDataSource';
import { Backend } from '../../api/Backend';
import { IScheduleDetailV5 } from '../../api/models/AndromeTV.types';
import { ListRibbon2Asset } from '../epg/ListRibbonDataSource';
import { EpgUtil } from '../utility/EpgUtil';
import { ActionMethod, AssetType, CardType, CmsProperty } from '../../api/models/Shared.types';
import { CardDataSource } from '../cms/CardDataSource';
import { ChannelModel } from '../../api/EpgApi.types';

export class ReminderGridDataSource extends GridDataSource {
  constructor(backend: Backend, channels: ChannelModel[], properties: CmsProperty[]) {
    super(backend, { url: '', properties: [] }, properties, channels);
    this.backend = backend;
  }

  override load(): Promise<ReminderGridDataSource> {
    return new Promise(resolve => {
      this.hasNextPage = false;
      this.backend.cachedReminderApi
        .getReminderList(this.backend)
        .then(reminders => {
          const ribbonAssets = reminders.map(reminder => this.scheduleDetailToRibbon2Asset(reminder.schedule));
          const filteredRibbonAssets = ribbonAssets.filter(Boolean) as ListRibbon2Asset[];
          this.sizeInfo.updateWithContainer(
            {
              items: filteredRibbonAssets,
              type: CardType.Landscape,
              nextPage: false,
            },
            this.cmsProperties
          );
          this.items = filteredRibbonAssets.map(
            ribbonAsset =>
              new CardDataSource(this.backend, ribbonAsset, this.sizeInfo, this.cmsProperties, this.channels)
          );
          resolve(this);
        })
        .catch(() => {
          this.items = [];
          resolve(this);
        });
    });
  }

  scheduleDetailToRibbon2Asset(schedule: IScheduleDetailV5): ListRibbon2Asset | undefined {
    return {
      asset: {
        type: AssetType.SCHEDULE,
        id: schedule.schedule.scheduleId,
        image: schedule.program.image.poster,
        published: schedule.schedule.published,
      },
      method: ActionMethod.DETAIL,
      channels: [
        {
          id: schedule.schedule.channelId,
          schedules: [
            {
              ...schedule.schedule,
              id: schedule.schedule.scheduleId,
              programId: schedule.schedule.programId,
            },
          ],
        },
      ],
      resources: [EpgUtil.programToRibbon2Detail(schedule.program, schedule.season ? [schedule.season] : [])],
    };
  }
}
